import { SLOT_IDX } from "./slotIdx";

/**
 * Weapons as a group, where one weapon's own art would say the wrong thing:
 * the type filter, and the criterion that asks for a weapon it has not chosen
 * yet. The slot's placeholder is a single sword, which reads as *this* weapon.
 */
export const WEAPON_GROUP_IMG = "/img/armes.png";

export const SLOTS = [
    { id: SLOT_IDX.HAT, name: { fr: "coiffe", en: "hat", de: "Haube", es: "tocado", pt: "chapéu" }, img: "/img/slot_coiffe.png" },
    { id: SLOT_IDX.CLOAK, name: { fr: "cape", en: "cloak", de: "Umhang", es: "capa", pt: "capa" }, img: "/img/slot_cape.png" },
    { id: SLOT_IDX.AMULET, name: { fr: "amulette", en: "amulet", de: "Amulett", es: "amuleto", pt: "amuleto" }, img: "/img/slot_amulette.png" },
    { id: SLOT_IDX.BELT, name: { fr: "ceinture", en: "belt", de: "Gürtel", es: "cinturón", pt: "cinto" }, img: "/img/slot_ceinture.png" },
    { id: SLOT_IDX.RING1, name: { fr: "anneau", en: "ring", de: "Ring", es: "anillo", pt: "anel" }, img: "/img/slot_anneau.png" },
    { id: SLOT_IDX.RING2, name: { fr: "anneau", en: "ring", de: "Ring", es: "anillo", pt: "anel" }, img: "/img/slot_anneau.png" },
    { id: SLOT_IDX.BOOTS, name: { fr: "bottes", en: "boots", de: "Stiefel", es: "botas", pt: "botas" }, img: "/img/slot_bottes.png" },
    { id: SLOT_IDX.WEAPON, name: { fr: "arme", en: "weapon", de: "Waffe", es: "arma", pt: "arma" }, img: "/img/slot_arme.png" },
    { id: SLOT_IDX.SHIELD, name: { fr: "bouclier", en: "shield", de: "Schild", es: "escudo", pt: "escudo" }, img: "/img/slot_bouclier.png" },
    { id: SLOT_IDX.PET, name: { fr: "familier", en: "pet", de: "Vertrauter", es: "mascota", pt: "mascote" }, img: "/img/slot_familier.png" },
    { id: SLOT_IDX.PRYSMARADITE, name: { fr: "prysma/dofus/trophée", en: "prisma/dofus/trophy", de: "Prysmaradit/Dofus/Trophäe", es: "prisma/dofus/trofeo", pt: "prisma/dofus/troféu" }, img: "/img/slot_dofus.png" },
    { id: SLOT_IDX.TROPHUS, name: { fr: "dofus/trophée", en: "dofus/trophy", de: "Dofus/Trophäe", es: "dofus/trofeo", pt: "dofus/troféu" }, img: "/img/slot_dofus.png" },
]

export const CAT = {
    GEAR: 0,
    TROPHUS: 1,
    PET: 2,
    WEAPON: 3,
};

/**
 * The filter categories, in the order every filter row shows them: the gear
 * that fills most of a build, then weapons, then the rest. One order, because
 * the search panel and the generator's settings are the same row of filters
 * and a user who learns where weapons are in one looks there in the other.
 */
export const TYPE_FILTER_ORDER = [
    CAT.GEAR,
    CAT.WEAPON,
    CAT.TROPHUS,
    CAT.PET,
];

export const getSlotName = (slotId, lang) => {
    let slot = SLOTS.find(s => s.id === slotId);
    if (!slot && SLOT_IDX.TROPHUS.includes(slotId)) {
        slot = SLOTS.find(s => s.id === SLOT_IDX.TROPHUS);
    }
    return slot ? slot.name[lang] : "";
}

export const getSlotImg = (slotId) => {
    let slot = SLOTS.find(s => s.id === slotId);
    if (!slot && SLOT_IDX.TROPHUS.includes(slotId)) {
        slot = SLOTS.find(s => s.id === SLOT_IDX.TROPHUS);
    }
    return slot ? slot.img : "";
}

export const TYPES = [
    { id: 1, name: { fr: "Amulette", en: "Amulet", de: "Amulett", es: "Amuleto", pt: "Amuleto" }, slot: SLOT_IDX.AMULET, category: CAT.GEAR, img: "/img/slot_amulette.png" },
    { id: 10, name: { fr: "Ceinture", en: "Belt", de: "Gürtel", es: "Cinturón", pt: "Cinto" }, slot: SLOT_IDX.BELT, category: CAT.GEAR, img: "/img/slot_ceinture.png" },
    { id: 11, name: { fr: "Bottes", en: "Boots", de: "Stiefel", es: "Botas", pt: "Botas" }, slot: SLOT_IDX.BOOTS, category: CAT.GEAR, img: "/img/slot_bottes.png" },
    { id: 9, name: { fr: "Anneau", en: "Ring", de: "Ring", es: "Anillo", pt: "Anel" }, slot: SLOT_IDX.RING1, category: CAT.GEAR, img: "/img/slot_anneau.png" },
    { id: 16, name: { fr: "Chapeau", en: "Hat", de: "Hut", es: "Sombrero", pt: "Chapéu" }, slot: SLOT_IDX.HAT, category: CAT.GEAR, img: "/img/slot_coiffe.png" },
    { id: 17, name: { fr: "Cape", en: "Cloak", de: "Umhang", es: "Capa", pt: "Capa" }, slot: SLOT_IDX.CLOAK, category: CAT.GEAR, img: "/img/slot_cape.png" },
    { id: 82, name: { fr: "Bouclier", en: "Shield", de: "Schild", es: "Escudo", pt: "Escudo" }, slot: SLOT_IDX.SHIELD, category: CAT.GEAR, img: "/img/slot_bouclier.png" },

    { id: 2, name: { fr: "Arc", en: "Bow", de: "Bogen", es: "Arco", pt: "Arco" }, slot: SLOT_IDX.WEAPON, category: CAT.WEAPON, img: "/img/arc.png" },
    { id: 3, name: { fr: "Baguette", en: "Wand", de: "Stab", es: "Varita", pt: "Varinha" }, slot: SLOT_IDX.WEAPON, category: CAT.WEAPON, img: "/img/baguette.png" },
    { id: 4, name: { fr: "Bâton", en: "Staff", de: "Stecken", es: "Bastón", pt: "Bastão" }, slot: SLOT_IDX.WEAPON, category: CAT.WEAPON, img: "/img/baton.png" },
    { id: 5, name: { fr: "Dague", en: "Dagger", de: "Dolch", es: "Daga", pt: "Adaga" }, slot: SLOT_IDX.WEAPON, category: CAT.WEAPON, img: "/img/dagues.png" },
    { id: 6, name: { fr: "Épée", en: "Sword", de: "Schwert", es: "Espada", pt: "Espada" }, slot: SLOT_IDX.WEAPON, category: CAT.WEAPON, img: "/img/epee.png" },
    { id: 7, name: { fr: "Marteau", en: "Hammer", de: "Hammer", es: "Martillo", pt: "Martelo" }, slot: SLOT_IDX.WEAPON, category: CAT.WEAPON, img: "/img/marteau.png" },
    { id: 8, name: { fr: "Pelle", en: "Shovel", de: "Schaufel", es: "Pala", pt: "Pá" }, slot: SLOT_IDX.WEAPON, category: CAT.WEAPON, img: "/img/pelle.png" },
    { id: 19, name: { fr: "Hache", en: "Axe", de: "Axt", es: "Hacha", pt: "Machado" }, slot: SLOT_IDX.WEAPON, category: CAT.WEAPON, img: "/img/hache.png" },
    { id: 22, name: { fr: "Faux", en: "Scythe", de: "Sense", es: "Guadaña", pt: "Foice" }, slot: SLOT_IDX.WEAPON, category: CAT.WEAPON, img: "/img/faux.png" },
    { id: 271, name: { fr: "Lance", en: "Lance", de: "Wurfspeer", es: "Pica", pt: "Lança" }, slot: SLOT_IDX.WEAPON, category: CAT.WEAPON, img: "/img/lance.png" },

    { id: 23, name: { fr: "Dofus", en: "Dofus", de: "Dofus", es: "Dofus", pt: "Dofus" }, slot: SLOT_IDX.TROPHUS, category: CAT.TROPHUS, img: "/img/slot_dofus.png" },
    { id: 151, name: { fr: "Trophée", en: "Trophy", de: "Trophäe", es: "Trofeo", pt: "Troféu" }, slot: SLOT_IDX.TROPHUS, category: CAT.TROPHUS, img: "/img/trophee_icon.png" },
    { id: 217, name: { fr: "Prysmaradite", en: "Prysmaradite", de: "Prysmaradit", es: "Prismaradita", pt: "Prismaradita" }, slot: SLOT_IDX.PRYSMARADITE, category: CAT.TROPHUS, img: "/img/prysmaradite.png" },

    { id: 18, name: { fr: "Familier", en: "Pet", de: "Vertrauter", es: "Mascota", pt: "Mascote" }, slot: SLOT_IDX.PET, category: CAT.PET, img: "/img/slot_familier.png" },
    { id: 121, name: { fr: "Montilier", en: "Petsmount", de: "Reitbegleiter", es: "Mascotura", pt: "Montascote" }, slot: SLOT_IDX.PET, category: CAT.PET, img: "/img/montilier_icon.png" },
    // Breed mounts (backend ItemTypes: DRAGOTURKEY = 331, SEEMYOOL = 332, RHINEETLE = 333)
    { id: 331, name: { fr: "Dragodinde", en: "Dragoturkey", de: "Dracotruter", es: "Dragopavo", pt: "Dragoperu" }, slot: SLOT_IDX.PET, category: CAT.PET, img: "/img/dragodinde_icon.png" },
    { id: 332, name: { fr: "Muldo", en: "Seemyool", de: "Seequagga", es: "Mulagua", pt: "Marmula" }, slot: SLOT_IDX.PET, category: CAT.PET, img: "/img/muldo_icon.png" },
    { id: 333, name: { fr: "Volkorne", en: "Rhineetle", de: "Naskäfer", es: "Vueloceronte", pt: "Vulkórnio" }, slot: SLOT_IDX.PET, category: CAT.PET, img: "/img/volkorne_icon.png" },
]

export const PRYSMA_ID = 217;

export const FILTER_TYPES = TYPES;

export const BREED_MOUNTS = [331, 332, 333];

// Group types by category
export const GROUPED_TYPES = FILTER_TYPES.reduce((groups, type) => {
    const groupKey = type.category;
    if (groupKey === undefined) return groups;
    if (!groups[groupKey]) groups[groupKey] = [];
    groups[groupKey].push(type);
    return groups;
}, {});

/**
 * Get default search filter type IDs for a slot.
 * Unlike getValidItemTypesForSlot, this includes all compatible types the user
 * may want to browse (e.g. prysma slot also shows trophy & dofus filters).
 */
export const getSearchFilterTypesForSlot = (slotId) => {
    const isPrysmaSlot = slotId === SLOT_IDX.PRYSMARADITE;
    const isTrophusSlot = Array.isArray(SLOT_IDX.TROPHUS) && SLOT_IDX.TROPHUS.includes(slotId);

    if (isPrysmaSlot) {
        return TYPES.filter(t => t.category === CAT.TROPHUS).map(t => t.id);
    }
    if (isTrophusSlot) {
        return TYPES.filter(t => t.slot === SLOT_IDX.TROPHUS).map(t => t.id);
    }
    return getValidItemTypesForSlot(slotId);
};

/**
 * Get item type IDs that are valid for a specific slot
 * @param {number} slotId - The slot ID to get valid types for
 * @returns {Array<number>} Array of item type IDs that can be equipped in this slot
 */
export const getValidItemTypesForSlot = (slotId) => {
    const isTrophusSlot = Array.isArray(SLOT_IDX.TROPHUS) && SLOT_IDX.TROPHUS.includes(slotId);
    const isPrysmaraditeSlot = slotId === SLOT_IDX.PRYSMARADITE;
    const isRingSlot = Array.isArray(SLOT_IDX.RINGS) && SLOT_IDX.RINGS.includes(slotId);

    return TYPES
        .filter(type => {
            if (isPrysmaraditeSlot) {
                // Prysmaradite slot (slot 10) only accepts prysmaradites
                return type.slot === SLOT_IDX.PRYSMARADITE;
            }
            if (isTrophusSlot) {
                // Other trophus slots (11-15) only accept regular trophus items, not prysmaradites
                return type.slot === SLOT_IDX.TROPHUS;
            }
            if (isRingSlot) {
                return type.slot === SLOT_IDX.RING1 || type.slot === SLOT_IDX.RING2;
            }
            return type.slot === slotId;
        })
        .map(type => type.id);
};

/**
 * Get the slot ID(s) for an item type ID
 * @param {number|string} itemTypeId - The item type ID (can be number or string)
 * @returns {number|Array<number>|null} The slot ID, array of slot IDs (for rings/trophus), or null if not found
 */
export const getSlotIdForItemType = (itemTypeId) => {
    // Convert to number for comparison (handles both string "16" and number 16)
    const numericTypeId = typeof itemTypeId === 'string' ? parseInt(itemTypeId, 10) : itemTypeId;

    if (isNaN(numericTypeId)) {
        return null;
    }

    const type = TYPES.find(t => t.id === numericTypeId);
    if (!type) {
        return null;
    }

    const slot = type.slot;

    // Handle special cases
    if (slot === SLOT_IDX.RING1) {
        return SLOT_IDX.RINGS; // Return array for rings
    }
    if (slot === SLOT_IDX.PRYSMARADITE) {
        return [SLOT_IDX.PRYSMARADITE]; // Prysmaradite can only go in the first trophus slot
    }
    if (slot === SLOT_IDX.TROPHUS) {
        return SLOT_IDX.TROPHUS; // Return array for trophus
    }

    return slot;
};

/**
 * Find an available slot for an item in a build
 * @param {number} itemTypeId - The item type ID
 * @param {Array} currentItems - Current items array from build
 * @returns {number|null} Available slot ID or null if no slot available
 */
export const findAvailableSlotForItem = (itemTypeId, currentItems) => {
    const slotId = getSlotIdForItemType(itemTypeId);
    // Fix: Check for null/undefined explicitly, not falsy (slot 0 is valid!)
    if (slotId === null || slotId === undefined) return null;

    // Handle array slots (rings, trophus)
    if (Array.isArray(slotId)) {
        // Find first empty slot in the array (treat out-of-range as empty)
        for (const slot of slotId) {
            if (slot >= currentItems.length || !currentItems[slot]) {
                return slot;
            }
        }
        // If all slots are full, use the first one (replace existing)
        return slotId[0];
    }

    // Single slot - return it (will replace if already occupied)
    return slotId;
};